<template>
    <div>
        <form @submit.prevent="pressOk">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <strong>País: {{ country.label }}</strong>
                    </div>
                    <div class="form-group">
                        <strong>Ciudad:</strong>
                        <input type="text" v-model="newCity.name" class="form-control no-limited" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <button class="btn btn-block btn-success">
                            <i class="fa fa-save"></i>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { Post, Get } from "../../helper/axios.js";
import toastr from "toastr";
export default {
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Post,
            Get,
        };
    },
    props: ["country", "newCity"],
    created() {
    },

    methods: {
        pressOk() {
            if (this.country) {
                var valid = true;
                var message = "";
                this.newCity.countryId = this.country.code;
                if (!this.newCity.name) {
                    message = "La Ciudad es Requerida";
                    valid = false;
                }
                if (valid) {
                    this.$emit("pressOk");
                } else {
                    toastr.info(message);
                }
            }
        },
    }
};
</script>